var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "smenu-edit" } },
    [
      _c(
        "Modal",
        {
          attrs: { title: _vm.modal.title, "footer-hide": "" },
          model: {
            value: _vm.modal.visible,
            callback: function ($$v) {
              _vm.$set(_vm.modal, "visible", $$v)
            },
            expression: "modal.visible",
          },
        },
        [
          _c("IForm", {
            key: _vm.modal.visible,
            attrs: {
              model: _vm.edit,
              elem: _vm.smenuElem,
              rules: _vm.smenuRule,
              loading: _vm.loading.form,
              "btn-loading": _vm.loading.btn,
              width: 360,
              "label-width": 100,
              button: "",
              "button-text": "取消",
            },
            on: {
              "on-submit": _vm.handleSubmit,
              "on-click": function ($event) {
                _vm.modal.visible = false
              },
              "on-change": _vm.change,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }